import React from "react";
import { Radio, Users, Briefcase, BrainCircuit, Compass, Infinity as InfinityIcon } from "lucide-react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

const ICONS = [Radio, Users, Briefcase, BrainCircuit, Compass, InfinityIcon];

export default function Features() {
  return (
    <section id="features" data-testid="features-section" className="relative py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[380px] w-[380px] -translate-x-1/2 glow-red opacity-40" />
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-2xl">
          <Reveal>
            <Eyebrow>Why ExcellenC</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
              An experience engineered around <span className="text-[#3B82F6]">your outcome.</span>
            </h2>
          </Reveal>
        </div>

        <StaggerGroup className="mt-14 grid gap-px overflow-hidden rounded-3xl border border-[#293891]/10 bg-[#293891]/[0.05] sm:grid-cols-2 lg:grid-cols-3">
          {COURSE.features.map((f, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <StaggerItem
                key={f.title}
                className="group relative bg-[#FFFFFF] p-8 transition-colors duration-500 hover:bg-[#F3F6FC]"
              >
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#e63329]/10 text-[#e63329] transition-transform duration-500 group-hover:scale-110">
                  <Icon size={20} />
                </div>
                <h3 className="mt-6 font-display text-lg font-medium text-[#293891]">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#566076]">{f.desc}</p>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
}
